var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95319 8.10727L5.53291 8.63384L5.53292 8.63384C6.57564 8.98142 7.09701 9.15521 7.4709 9.5291C7.84479 9.90299 8.01858 10.4244 8.36615 11.4671L8.36616 11.4671L8.89273 13.0468C9.77122 15.6823 10.2105 17 11.0177 17C11.8249 17 12.2641 15.6823 13.1426 13.0468L13.1426 13.0468L16.3207 3.51256C16.9388 1.65818 17.2479 0.730982 16.7584 0.24155C16.269 -0.247882 15.3418 0.0611818 13.4874 0.67931L3.95319 3.85739C1.31773 4.73588 0 5.17512 0 5.98233C0 6.78954 1.31773 7.22878 3.95318 8.10727L3.95319 8.10727Z",
    fill: "#021D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00665 10.285L3.6977 9.51536C3.36983 9.40607 3.00987 9.45428 2.72231 9.64598L1.50343 10.4586C0.856246 10.89 1.02852 11.8846 1.78311 12.0733L3.97205 12.6205C4.17268 12.6706 4.32933 12.8273 4.37949 13.0279L4.92672 15.2169C5.11537 15.9715 6.10995 16.1437 6.5414 15.4965L7.35399 14.2777C7.5457 13.9901 7.5939 13.6301 7.48461 13.3023L6.71496 10.9933C6.60349 10.6589 6.34107 10.3965 6.00665 10.285Z",
    fill: "#021D4D",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendbutton);
export default __webpack_public_path__ + "static/media/sendbutton.b49fc66fd733d4d0ea71e2241f1085c7.svg";
export { ForwardRef as ReactComponent };